<section>
  <div class="icon-text header">
    <div class="custom-icon billing_dollar"></div>
    <h1>Billing</h1>
  </div>

  @if ((isLoadingInvoices$ | async) && (isLoadingPayments$ | async)) {
    <div class="loading-indicator">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else {
    <div class="billing-widget-wrapper">
      @if (invoiceDate$ | async; as invoiceDate) {
        <div class="invoice-container">
          <img class="invoice-image" alt="invoice icon" src="/assets/images/img_widget_invoice_std@2x.png" />
          <div class="invoice-detail">
            <h2>Invoice</h2>
            <div class="posted-date">posted {{ invoiceDate | date: 'MMM d, y.' }}</div>
          </div>
        </div>
      } @else {
        <div class="invoice-container">
          <img class="invoice-image" alt="invoice icon" src="/assets/images/img_widget_invoice_empty@2x.png" />
          <div class="invoice-detail">
            <h2 class="empty">No Invoices.</h2>
          </div>
        </div>
      }

      @if (payment$ | async; as payment) {
        <div class="payment-container">
          <h2>Payment</h2>
          <div class="posted-date">posted {{ payment.Transaction_Date__c | date: 'MMM d, y.' }}</div>
          <div class="payment-value">
            <span>$</span>{{ getPaymentDollars(payment) }}<span>{{ getPaymentCents(payment) }}</span>
          </div>
        </div>
      } @else {
        <div class="payment-container">
          <h2 class="empty">No Payment Yet.</h2>
          <div class="payment-value"><span>$</span>&nbsp;- - -</div>
        </div>
      }
    </div>
  }

  <div class="widget_cta"><a routerLink="/billing">View Billing</a></div>
  <a routerLink="/billing" tabindex="-1" class="dashboard-link desktop"><div class="cta-link">desktop</div></a>
</section>
